import { type IntlShape } from "react-intl";
import { z } from "zod";

import { dataPipelineSchema } from "./routing/selection-pipeline";

export const productionGroupSchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	alias: z.string(),
	description: z.string().nullish(),
	configuredMachineGroups: z.array(z.string()),
	configuredCorrugates: z.array(z.string()).optional(),
	manualScanToProduce: z.string().nullish(),
	pipelineId: z.string().optional(),
	maxTileCount: z.number().optional(),
});

export const deleteProductionGroupSchema = z.object({
	deleted: z.boolean(),
	failReason: z.string().nullish(),
});

export const createProductionGroupSchema = productionGroupSchema
	.omit({ id: true, tenantId: true, maxTileCount: true })
	.extend({ id: z.string().optional() });

export const updateProductionGroupSchema = productionGroupSchema;

export type ProductionGroup = z.infer<typeof productionGroupSchema>;
export type CreateProductionGroup = z.infer<typeof createProductionGroupSchema>;
export type UpdateProductionGroup = z.infer<typeof updateProductionGroupSchema>;
export type DeleteProductionGroup = z.infer<typeof deleteProductionGroupSchema>;

export const getProductionGroupConfigurationSchema = (intl: IntlShape) =>
	z.object({
		alias: z
			.string(intl.formatMessage({ id: "Name needs to be a string", defaultMessage: "Name needs to be a string" }))
			.trim()
			.nonempty(intl.formatMessage({ id: "Name is required", defaultMessage: "Name is required" }))
			.max(
				100,
				intl.formatMessage({
					id: "Name must be less than 100 characters",
					defaultMessage: "Name must be less than 100 characters",
				}),
			),
		description: z
			.string(
				intl.formatMessage({
					id: "Description needs to be a string",
					defaultMessage: "Description needs to be a string",
				}),
			)
			.trim(),
		configuredMachineGroups: z.array(z.string()),
		configuredCorrugates: z.array(z.string()),
		manualScanToProduce: z.string(),
		pipeline: dataPipelineSchema,
	});

export type ProductionGroupConfiguration = z.infer<ReturnType<typeof getProductionGroupConfigurationSchema>>;
